import { createSelector } from 'redux-orm';
import { orm } from 'model';

// eslint-disable-next-line import/prefer-default-export
export const selector = createSelector(orm.ViewAs);
